import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import { User } from '@/api/auth';
import { isProduction } from '@/helpers/common';
import { groupMemberDepositor, groupMemberVIP } from '@/helpers/user';
import { useCommonStore, useLocalStorageStore } from '@/store';

enum HotjarMode {
  ON,
  OFF,
}

type HotjarMap = {
  [key in HotjarMode]: {
    identifyUser: (user: User, stag: string | null) => void;
  };
};

const hotjarMap: HotjarMap = {
  [HotjarMode.ON]: {
    identifyUser: (user, stag) => {
      try {
        // @ts-ignore
        window.hj('identify', user.id || null, {
          email: user.email,
          vip: groupMemberVIP(user) ? 'YES' : 'NO',
          depositor: groupMemberDepositor(user) ? 'YES' : 'NO',
          groups: user.statuses?.map(({ id }) => id).join(', ') || null,
          stag: stag,
          // TODO: Add profile data
          // profile: profileGroup,
        });
      } catch (error) {
        Sentry.captureException(JSON.stringify(error), {
          tags: {
            category: 'hotjar',
            pathToFile: 'src/hooks/3dParty/hotjar.tsx',
          },
          level: 'warning',
        });

        console.error('Hotjar identifyUser failed');
      }
    },
  },
  [HotjarMode.OFF]: {
    identifyUser: () => {},
  },
};

const Hotjar = isProduction()
  ? hotjarMap[HotjarMode.ON]
  : hotjarMap[HotjarMode.OFF];

export const useHotjar = () => {
  const user = useCommonStore.use.user();

  const storageStag = useLocalStorageStore
    .getState()
    .get<string | null>('stag', null);

  useEffect(() => {
    if (!user) return;

    Hotjar.identifyUser(user, storageStag);
  }, [user, storageStag]);
};
